import { createFileRoute } from '@tanstack/react-router';

import { OrderForm } from '@/components/orders/order-form';
import { useDetailTitle } from '@/components/page-header';
import { useAuth } from '@/lib/auth';

/**
 * A static segment, so it takes precedence over `/orders/$orderId` and "new"
 * is never mistaken for an id.
 */
export const Route = createFileRoute('/orders/new')({
  component: NewOrderPage,
});

function NewOrderPage() {
  const { activeAccountId } = useAuth();

  useDetailTitle('New order');

  if (!activeAccountId) {
    return <p className="text-muted-foreground text-sm">Choose a workspace first.</p>;
  }

  return <OrderForm accountId={activeAccountId} />;
}
